<template>
    <div   style="position: relative;width: 100vw;height: 100vh;">
  <v-card  width="80%"  class="white--text" style="max-width: 450px;letter-spacing: 3px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%)">
    <v-card-title class="mb-5 pt-3 pb-3 title"  style="text-align: center!important; display: block; background-color:#1976d2;letter-spacing: 3px!important;">新規登録</v-card-title>
    <div class="pb-7 pr-7 pl-7 "> 
    
    <v-text-field outlined dense class="mb-1" label="メールアドレス" type="text" v-model="mailaddress"></v-text-field>
    
    <v-text-field outlined dense class="mb-1" label="パスワード" type="text" v-model="password"></v-text-field>
     
    
    <v-btn class=" pb-2 pt-2 white--text" @click="signUp" color="green darken-1 ">登録する</v-btn>
     <span class="text-center subtitle-1 mt-2 mb-2">or</span>
      <v-btn class=" pb-2 pt-2 " to="/signin" >ログイン画面に戻る</v-btn>
     </div>
  </v-card>
  
    <div>
      
    </div>
   
  </div>
</template>
<script>
import firebase from 'firebase'
import router from '../router'
export default {
      
    data() {
        return {
          mailaddress: '',
          password: '',
        }
    },
    methods: {
    
    signUp: function () {
      firebase.auth().createUserWithEmailAndPassword(this.mailaddress, this.password).then(function(){
          alert('登録に成功しました。\nログイン画面に戻ります。');
          router.push("signIn");
           
          
      }).catch(function(error){
          alert(error.message);

      })
      
    }
  }
}                                                                                                                                   
</script>
<style scoped>
 input {
  display: block!important;
  border: 1px solid #999;
  width: 100%;
}
span {
  color: #333;
  font-size: 12px;
  display: block;
  
}

.v-btn {
  display: block!important;
  width: 100%;
  height: auto!important;
}
</style>
